import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { Email } from "../email";
import type { OwnerId } from "../owner-id";
import type { UserId } from "../users/user-id";

type NotificationId = Branded<string, "NotificationId">;

const {
    factory: notificationIdFactory,
    assert: isNotificationId,
    zodSchema: notificationIdZodSchema,
} = genericId<NotificationId>("notification__", {
    regexMatch: /(^notification_.*$)/,
});

//TODO is notification a good name???
type NotificationBase = {
    readonly _id: NotificationId;
    readonly _type: "NOTIFICATION";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly ownerId: OwnerId; //Can be created by a provider for a user

    readonly paused: boolean;
};

type NotificationEmail = NotificationBase & {
    type: "EMAIL";
    userId?: UserId; //Specific user
    email: Email;
    readonly onEvent: SUPPORTED_EMAIL_EVENTS[];
};

type FactoryParams = Except<NotificationEmail, "_id" | "_type" | "_createdAt">;
const emailNotificationFactory = (params: FactoryParams) => {
    const AddnotificationCommand: NotificationEmail = {
        ...params,
        _id: notificationIdFactory(),
        _type: "NOTIFICATION",
        type: "EMAIL",
        _createdAt: nowIsoAndUnix(),
    };
    return AddnotificationCommand;
};

const notificationEvents = ["SETTLEMENT_NOTE", "NEW_ORDER"]; //What more
type SUPPORTED_EMAIL_EVENTS = (typeof notificationEvents)[number];

type Notifications = NotificationEmail;

export {
    emailNotificationFactory,
    isNotificationId,
    notificationEvents,
    notificationIdZodSchema,
};
export type { NotificationEmail, Notifications, SUPPORTED_EMAIL_EVENTS };
